module.exports = __webpack_public_path__ + "static/media/KOM_02.8300c449.png";